module.exports = "/images/bwcommerce.png?b8a413a81fa80554bd39e2a87ade708b";